import { IActionButtonV2Schema } from '../../repositories/chats/entities/message/ActionButtonV2Schema';

// матчит строку вида cianurl://cian.ru/daily_rent/write_review/289006885/?tripStatus=success
const URL_REGEX = /(cianurl:\/\/cian.ru\/daily_rent\/write_review\/)(\d+)(\/\?tripStatus=success)/gi;

export const doesButtonHaveDailyrentReviewLink = ({ link }: IActionButtonV2Schema) => {
  return link && link.match(URL_REGEX)?.length;
};

export const shouldShowDailyrentReviewButtons = (actionButtons: IActionButtonV2Schema[] | undefined): boolean => {
  if (!actionButtons) {
    return false;
  }

  return actionButtons.some(doesButtonHaveDailyrentReviewLink);
};
